import http from 'conversations-http/clients/http';
export const fetchMessageLimitData = args => {
  return http.put('conversations-channels/v1/quota', {
    data: {
      genericChannelId: args.genericChannelId,
      senderDeliveryIdentifier: args.agentDeliveryIdentifier,
      recipientDeliveryIdentifiers: args.visitorDeliveryIdentifiers
    }
  });
};